import { Slider as SliderAntd } from "antd";
import "./index.css";

const Slider = ({ ...props }) => {
  return <SliderAntd {...props} />;
};

export default Slider;
